import { PrivilegiosService } from 'app/servicios/privilegios.service';
import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute, Routes } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../servicios';
import { OlvidopassComponent } from '../componentes/olvidopass/olvidopass.component';


import { ConfigService } from '../servicios/config.service';
import { CatSucursales, Config } from '../entidades/entidades';
import { CatSucursalesService } from 'app/servicios/cat-sucursales.service';
import { MuestraMensaje } from 'app/shared/utilerias/notificaciones/notificaciones.component';

@Component({
    templateUrl: "login.component.html",
    styleUrls: ['login.component.css']
})


export class LoginComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    error = "";
    fecha = Date.now();
    config: Config;
    sucursales :CatSucursales[] = [];
    muestraMensaje = new MuestraMensaje();


    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private privilegiosService: PrivilegiosService,
        private configService: ConfigService,
        private catSucursalesService: CatSucursalesService
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.currentUserValue) {
            this.router.navigate(["/"]);
        } else {
            this.loginForm = this.formBuilder.group({
                username: ["", Validators.required],
                password: ["", Validators.required],
                sucursal: ["", Validators.required],
            });
            this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "/";
        }
    }

    display: boolean = false;
    showDialog() {
        this.display = true;
    }
    async ngOnInit() {
        if (this.config === undefined) {
            this.config = await this.configService.getBaseUrlApiWeb();
            let configJson = JSON.stringify(this.config);
            localStorage.setItem('config', configJson);
        }
        await  this.cargaSucursales();
        this.logout();
    }


    // convenience getter for easy access to form fields
    get f() {
        return this.loginForm.controls;
    }

    async onSubmit() {
        /*console.log("eeeeeeeeeeeeeeEEEEEEEEEE");*/
        

        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        let info: string;
        info = await this.privilegiosService.GetInfoBrowser().toPromise();

        this.authenticationService
            .login(this.f.username.value, this.f.password.value, info)
            .pipe(first())
            .subscribe(
                (data) => {
                    this.router.navigate(["/dashboard/dashboard"]);
                    //actualizar el usuario, con la sucursal seleccionada.
                    if(this.f.sucursal!=null && this.f.sucursal.value!=null)
                       this.catSucursalesService.setSucursalByUser(this.f.sucursal.value.toString(),"1","1").toPromise();
                },
                (error) => {
                    this.error = error;
                    this.loading = false;
                }
            );
    }
    async onPasswordFocus() 
    {
        await this.cargaSucursales();
        const usernameControl = this.loginForm.get('username');
        const sucursalControl = this.loginForm.get('sucursal');
        if (usernameControl && usernameControl.value && sucursalControl && sucursalControl.value == "") {
            const username = usernameControl.value;
            try {
                const sucursalUser = await this.catSucursalesService.getSucursalByUser(username, "0", "1").toPromise();
                if (sucursalUser && sucursalControl && !sucursalControl.value) {
                    sucursalControl.setValue(sucursalUser.id);
                }
            } catch (error) {
                console.error('Error retrieving sucursal:', error);
            }
        }
   }
   async cargaSucursales() {
    try{
        if (this.sucursales.length > 0) {
            return;
        }
        //carga surcusales.
        this.sucursales = await this.catSucursalesService.getAll().toPromise();
        this.sucursales = this.sucursales.filter(sucursal => sucursal.id !== 2);// quito la sucursal de pago en linea.
    }catch(error){
        this.muestraMensaje.error(error.message, "top", "center");
    }

    }
    async logout() {
        try{
            var tokenActivo: string = localStorage.getItem("tokenActivo");
            console.log("tokenActivo: ", tokenActivo);
            if(tokenActivo == null || tokenActivo == "" ){
                this.authenticationService.deleteLocalStorage();
            }else{
                this.authenticationService.deleteLocalStorage();
                console.log("tokenActivo: ", tokenActivo);
                await   this.authenticationService.logout(tokenActivo);
            }
            
            localStorage.removeItem("pageReloaded");
            localStorage.removeItem("tokenActivo");
            this.authenticationService.deleteLocalStorage();
        }catch(error){            
            localStorage.removeItem("pageReloaded");
            localStorage.removeItem("tokenActivo");
            this.muestraMensaje.error(error.message, "top", "center");
        }
    }
}

